import React from 'react';
import { Nav } from './Components/Nav/Nav';
import './App.css';
import { Route, Routes } from 'react-router';
import Games from './Pages/Games/Games';
import { About } from './Pages/About/About';
import { Resume } from './Pages/Resume/Resume';

function App() {
  return (
      <div className='appWrapper'>
        <Nav />
        <Routes>
          <Route path='/' element={<Games />}/>
          <Route path='/games' element={<Games />}/>
          <Route path='/about' element={<About />}/>
          <Route path='/resume' element={<Resume />}/>
        </Routes>
      </div>
  );
}

export default App;
